// Import filter types from central models
import type { 
  TextFilterOperator, 
  NumberFilterOperator, 
  DateFilterOperator, 
  SelectFilterOperator,
  FilterOperator,
  ColumnFilter,
  SortDirection,
  SortOption
} from '../../models/app.models';

// Re-export filter types from central models
export type { 
  TextFilterOperator, 
  NumberFilterOperator, 
  DateFilterOperator, 
  SelectFilterOperator,
  FilterOperator,
  ColumnFilter,
  SortDirection,
  SortOption
};

// Filter Operator Labels
export const FILTER_OPERATOR_LABELS: Record<FilterOperator, string> = {
  // Text operators
  equals: 'Equals',
  doesNotEqual: 'Does not equal',
  contains: 'Contains',
  doesNotContain: 'Does not contain',
  startsWith: 'Starts with',
  endsWith: 'Ends with',
  // Number operators
  greaterThan: 'Greater than',
  lessThan: 'Less than',
  between: 'Between',
  // Date operators
  before: 'Before',
  after: 'After',
  today: 'Today',
  thisWeek: 'This week',
  thisMonth: 'This month',
  // Select operators
  isOneOf: 'Is one of',
  isNotOneOf: 'Is not one of'
};

// Get available operators by column type
export function getAvailableOperators(columnType: string): FilterOperator[] {
  switch (columnType) {
    case 'text':
    case 'link':
      return ['equals', 'doesNotEqual', 'contains', 'doesNotContain', 'startsWith', 'endsWith'];
    case 'number':
      return ['equals', 'doesNotEqual', 'greaterThan', 'lessThan', 'between'];
    case 'date':
      return ['equals', 'doesNotEqual', 'before', 'after', 'between', 'today', 'thisWeek', 'thisMonth'];
    case 'badge':
    case 'select':
      return ['isOneOf', 'isNotOneOf'];
    default:
      return ['equals', 'doesNotEqual', 'contains', 'doesNotContain'];
  }
}

export function getDefaultOperator(columnType: string): FilterOperator {
  switch (columnType) {
    case 'text':
    case 'link':
      return 'contains';
    default:
      return getAvailableOperators(columnType)[0];
  }
}

// Filter State Interface, Sort Direction, and Sort Option are now exported from app.models.ts

